
//Libs
import { useEffect, useRef, useState } from 'react';
import React from 'react';
import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import 'react-toastify/dist/ReactToastify.css';

//Utils
import Loader from '../../components/loader';
import Layout from '../../components/Layout';
import Spinner from '../../components/spinner';
import { errorMessage } from '../../utils/utils';
import api from '../../utils/api';

//Icons
import { TiEdit, TiWarning } from "react-icons/ti";
import { FaArrowRightLong, FaCircleCheck, FaExclamation } from 'react-icons/fa6';
import { FaCheckCircle, FaClipboard, FaClipboardCheck, FaExclamationCircle, FaRegCheckCircle, FaRegClipboard, FaRegQuestionCircle, FaTimesCircle } from 'react-icons/fa';
import { PiWarningDiamondFill } from 'react-icons/pi';
import { IoIosArrowDown, IoIosArrowForward, IoIosSettings, IoMdAddCircleOutline, IoMdInformationCircleOutline, IoMdRefreshCircle } from 'react-icons/io';
import { FaCheck, FaQuestion } from 'react-icons/fa6';
import { RiDeleteBin5Fill } from 'react-icons/ri';
import { HiWrenchScrewdriver } from "react-icons/hi2";
import { MdChangeCircle } from 'react-icons/md';
import { CiServer } from 'react-icons/ci';
import { PiLinkFill } from 'react-icons/pi';
import { ErrorState, Pill } from '../../components/ui';
import { ListEmpty, ListHeader, ListLoading } from '../../components/ListToolbar';
import { PaymentNoticeDialog } from '../../components/PaymentNotice';


export default function Remote() {

    const [pageLoading, setPageLoading] = useState(true);

    const [itemsError, setItemsError] = useState('');
    const [itemsLoading, setItemsLoading] = useState(true);
    const [items, setItems] = useState<any[]>([]);

    const [activeId, setActiveId] = useState('');
    const [copiedId, setCopiedId] = useState('');

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState('');
    const [confirmTitle, setConfirmTitle] = useState('');

    const [actionId, setActionId] = useState('');
    const [action, setAction] = useState('');
    const [actionLoading, setActionLoading] = useState(false);
    const [actionError, setActionError] = useState('');
    const [actionMessage, setActionMessage] = useState('');

    const [statusLoading, setStatusLoading] = useState(false);
    const [statusList, setStatusList] = useState<any>();

    const [showDeleted, setShowDeleted] = useState(false);

    const [isOpenChangeServerModal, setOpenChangeServerModal] = useState(false);
    const [changeServerData, setChangeServerData] = useState<any>();

    const [servers, setServers] = useState<any[]>();


    useEffect(() => {
        if (!window.localStorage.token) {
            window.location.replace('/signin');
            return;
        }

        setPageLoading(false);
        const deleted = window.localStorage.deleted;
        setShowDeleted(deleted === 'true');
        getItems(deleted === 'true');

    }, []);

    function clearConfirm() {
        setConfirmOpen(false);

        setActionId('');
        setAction('');
        setActionLoading(false);
        setActionMessage('');
        setActionError('');

        if (actionMessage) {
            getItems(showDeleted);
        }
    }

    async function getItems(deleted?: boolean) {
        setItems([]);
        setActiveId('');
        setItemsLoading(true);
        try {
            const res = await api.get(`/remote${deleted ? '?deleted=true' : ''}`);
            const json = await res.json();
            if (res.ok) {
                setItems(json);
                getConnectionStatus();
            } else {
                setItemsError(errorMessage(json));
            }

        } catch (error) {
            setItemsError(errorMessage(error));
        }

        setItemsLoading(false);
    }

    async function remove(id: string) {

        setActionLoading(true);

        try {
            const res = await api.delete(`/remote/${id}`);
            const json = await res.json();
            if (res.ok) {
                setActionMessage(json.message);
            } else {
                setActionError(errorMessage(json));
            }

        } catch (error) {
            setActionError(errorMessage(error));
        }
        setActionLoading(false);

    }

    async function reconnect(id: string) {

        setActionLoading(true);
        try {
            const res = await api.post(`/remote/disc/${id}`);
            const json = await res.json();
            if (res.ok) {
                setActionMessage(json.message);
            } else {
                setActionError(errorMessage(json));
            }
        } catch (error) {
            setActionError(errorMessage(error));
        }
        setActionLoading(false);
    }

    async function fixremote(id: string) {

        setActionLoading(true);
        try {
            const res = await api.post(`/remote/fix/${id}`);
            const json = await res.json();
            if (res.ok) {
                setActionMessage(json.message);
            } else {
                setActionError(errorMessage(json));
            }
        } catch (error) {
            setActionError(errorMessage(error));
        }
        setActionLoading(false);
    }

    // async function reconfig(id: string) {

    //     setActionLoading(true);
    //     try {
    //         const res = await api.post(`/remote/conf/${id}`);
    //         const json = await res.json();
    //         if (res.ok) {
    //             setActionMessage(json.message);
    //         } else {
    //             setActionError(errorMessage(json));
    //         }
    //     } catch (error) {
    //         setActionError(errorMessage(error));
    //     }
    //     setActionLoading(false);
    // }

    async function executeConfirm() {

        if (!actionId) {
            clearConfirm();
            return;
        }

        switch (action) {
            case 'delete':
                remove(actionId);
                break;
            case 'reconnect':
                reconnect(actionId);
                break;
            // case 'reconfig':
            //     reconfig(actionId);
            //     break;
            case 'fixremote':
                fixremote(actionId);
                break;
            default:
                clearConfirm();
        }
    }


    function copyValue(key: string, value: string) {
        navigator.clipboard.writeText(value);
        setCopiedId(key);
        setTimeout(() => setCopiedId(''), 1500);
    }

    function CopyRow({ label, value, disabled }: any) {
        if (!value) return null;
        const key = `${label}-${value}`;
        return (
            <div className="flex flex-row items-center gap-2 rounded-xl bg-slate-50 px-3 py-2 ring-1 ring-slate-200">
                <span className="w-[74px] shrink-0 text-[11px] font-semibold uppercase tracking-wide text-slate-400">{label}</span>
                <span className="grow truncate text-sm font-semibold text-slate-800">{value}</span>
                {!disabled && (
                    <button
                        type="button"
                        aria-label={`Copy ${label}`}
                        className="shrink-0 rounded-md p-1 text-slate-400 transition hover:bg-white hover:text-emerald-600"
                        onClick={(e) => { e.preventDefault(); copyValue(key, value); }}>
                        {copiedId === key ? <FaClipboardCheck size={14} className="text-emerald-500" /> : <FaRegClipboard size={14} />}
                    </button>
                )}
            </div>
        );
    }

    /** Chevron toggle, matching the MikRouter admin remotes row. */
    function ExpandButton({ item }: any) {
        const open = activeId === item.id;
        return (
            <button
                type="button"
                onClick={(e) => { e.preventDefault(); setActiveId(open ? '' : item.id); }}
                aria-label={open ? 'Hide details' : 'Show details'}
                className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-600">
                <svg viewBox="0 0 20 20" fill="currentColor" className={`h-4 w-4 transition ${open ? 'rotate-90' : ''}`}>
                    <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 0 1 .02-1.06L11.168 10 7.23 6.29a.75.75 0 1 1 1.04-1.08l4.5 4.25a.75.75 0 0 1 0 1.08l-4.5 4.25a.75.75 0 0 1-1.06-.02Z" clipRule="evenodd" />
                </svg>
            </button>
        );
    }

    /** Actions + credentials, revealed by ExpandButton. */
    function CardActions({ item, status, errors }: any) {
        const open = activeId === item.id;
        const remoteUrl = `${item.from_address}:${item.from_port}`;

        // Live values only exist once the status poll returns for this account.
        const { uptime, remote_ip }: any = getData(item, statusList);
        const expiration = item.date_expiration ? moment(item.date_expiration).format('LL') : null;

        let daysLeft: any = null;
        if (item.date_expiration) {
            const diff = moment(item.date_expiration).diff(moment(), 'days');
            daysLeft = `${diff} day${diff === 1 ? '' : 's'}`;
        }

        const deletion = item.date_delete ? moment(item.date_delete).format('LL') : null;
        const deleteDays = deletion ? `in ${moment(item.date_delete).diff(moment(), 'days')} day(s)` : null;

        function Stat({ label, value }: any) {
            if (!value) return null;
            return (
                <div className="min-w-0">
                    <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-slate-400">{label}</p>
                    <p className="truncate text-sm font-semibold text-slate-800">{value}</p>
                </div>
            );
        }

        return (
            <>
                {open && (
                    <div className="flex flex-col gap-4 border-t border-slate-100 bg-slate-50/60 px-5 py-5 lg:pl-16 lg:pr-8">

                        {errors?.length > 0 && (
                            <div className="rounded-xl bg-amber-50 px-3 py-2 text-[11px] font-medium text-amber-700 ring-1 ring-amber-100">
                                {errors.map((text: any, i: number) => <div key={`${i}-err`}>{text}</div>)}
                            </div>
                        )}

                        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
                            <Stat label="Status" value={item.deleted ? 'Deleted' : status ?? 'unknown'} />
                            <Stat label="Uptime" value={uptime} />
                            <Stat label="Remote IP" value={remote_ip} />
                            <Stat label="Service" value={item.service?.toUpperCase()} />
                            <Stat label="Application" value={item.to_port} />
                            <Stat label="Expires On" value={expiration} />
                            <Stat label="Days Left" value={daysLeft} />
                        </div>

                        {deletion && (
                            <div className="rounded-xl bg-red-50 px-3 py-2 text-[11px] font-medium italic text-red-600 ring-1 ring-red-100">
                                This account will be automatically deleted on {deletion} ({deleteDays}) if not renewed
                            </div>
                        )}

                        <div className="flex flex-col gap-2">
                            <CopyRow label="URL" value={remoteUrl} disabled={item.expired} />
                            <CopyRow label="Server" value={item.from_address} disabled={item.expired} />
                            <CopyRow label="User" value={item.user} disabled={item.expired} />
                            <CopyRow label="Password" value={item.password} disabled={item.expired} />
                        </div>

                        <div className="flex flex-row flex-wrap gap-2">
                            <button
                                type="button"
                                disabled={item.deleted || item.expired}
                                onClick={(e) => { e.preventDefault(); confirmAction('change', item); }}
                                className="inline-flex min-h-[34px] items-center gap-1.5 rounded-full bg-emerald-600 px-3.5 text-xs font-semibold text-white transition hover:bg-slate-950 disabled:bg-slate-300">
                                <MdChangeCircle size={15} />Change Server
                            </button>

                            <button
                                type="button"
                                disabled={status !== 'online' || actionId === item.id}
                                onClick={(e) => { e.preventDefault(); confirmAction('fixremote', item); }}
                                className="inline-flex min-h-[34px] items-center gap-1.5 rounded-full bg-white px-3.5 text-xs font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-100 disabled:text-slate-300">
                                <HiWrenchScrewdriver size={13} />Fix remote
                            </button>

                            <button
                                type="button"
                                disabled={status !== 'online' || actionId === item.id}
                                onClick={(e) => { e.preventDefault(); confirmAction('reconnect', item); }}
                                className="inline-flex min-h-[34px] items-center gap-1.5 rounded-full bg-white px-3.5 text-xs font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-100 disabled:text-slate-300">
                                <IoMdRefreshCircle size={15} />Reconnect
                            </button>

                            <a
                                href={`/remote/${item.ref ?? ''}`}
                                className="inline-flex min-h-[34px] items-center gap-1.5 rounded-full bg-white px-3.5 text-xs font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-100">
                                <TiEdit size={15} />Edit
                            </a>

                            <button
                                type="button"
                                disabled={!!actionId || item.deleted}
                                onClick={(e) => { e.preventDefault(); confirmAction('delete', item); }}
                                className="inline-flex min-h-[34px] items-center gap-1.5 rounded-full bg-white px-3.5 text-xs font-semibold text-red-600 ring-1 ring-inset ring-red-200 transition hover:bg-red-50 disabled:text-slate-300 disabled:ring-slate-200">
                                <RiDeleteBin5Fill size={14} />Delete
                            </button>
                        </div>

                        <a
                            href={`https://kptd.ph/remote/tutorials/how-to-connect-${item.service}-client${item.service === 'sstp' && item.service_port ? `?port=${item.service_port}` : ''}`}
                            rel="noreferrer"
                            target="_blank"
                            className="text-[11px] font-semibold text-emerald-700 hover:underline">
                            How to install {item.service} client on MikroTik
                        </a>

                    </div>
                )}
            </>
        );
    }

    function confirmAction(action: string, obj: any) {

        switch (action) {

            case 'delete':
                setActionId(obj.id);
                setAction(action);
                setConfirmTitle(`Delete ${obj.label ?? obj.user}`);
                setConfirmMessage(`Are you sure you want to delete <b>${obj.label ?? obj.user}?</b><br />This action cannot be undone.`);
                setConfirmOpen(true);
                break;
            case 'reconnect':
                setActionId(obj.id);
                setAction(action);
                setConfirmTitle(`Reconnect ${obj.label ?? obj.user}`);
                setConfirmMessage(`Are you sure you want to disconnect <b>${obj.label ?? obj.user}?</b><br />This account will automatically reconnect shortly.<br /><br />This action can resolve the missing or invalid nat configuration, if present.`);
                setConfirmOpen(true);
                break;
            // case 'reconfig':
            //     setConfirmTitle(`Reconfig ${obj.label ?? obj.user}`);
            //     setConfirmMessage(`This can fix the error missing or invalid address or route`);
            //     break;
            case 'fixremote':
                setActionId(obj.id);
                setAction(action);
                setConfirmTitle(`Fix ${obj.label ?? obj.user}`);
                setConfirmMessage(`This can fix the error remote access not available`);
                setConfirmOpen(true);
                break;
            case 'change':
                setChangeServerData(obj);
                setOpenChangeServerModal(true);
                break;
        }

    }

    async function getConnectionStatus() {
        setStatusLoading(true);
        try {

            const res = await api.get('remote/status');
            const json = await res.json();

            if (res.ok) {
                setStatusList(json);
            } else {
                setItemsError(json.error);
            }

        } catch (error) {
            setItemsError(errorMessage(error));
        }

        setStatusLoading(false);
    }

    if (pageLoading) {
        return (<div className='w-screen h-screen text-center flex flex-col bg-white justify-center'><Loader /></div>)
    }

    return (
        <>
            <Layout nav='remote' title='My Remote Accounts'>

                <section className="mx-auto w-full max-w-5xl px-5 py-8 sm:px-8">

                    <ListHeader
                        eyebrow="Accounts"
                        title="Remote Accounts"
                        description="Reach your routers from anywhere."
                        actions={<>
                            <label htmlFor="show-delete" className='hidden cursor-pointer flex-row items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-medium text-slate-600 sm:flex'>
                                <input type="checkbox" id='show-delete' checked={showDeleted} className='h-4 w-4 cursor-pointer rounded border-slate-300 text-emerald-600 focus:ring-emerald-500' onChange={(e) => {
                                    const value = e.target.checked;
                                    window.localStorage.deleted = value;
                                    setShowDeleted(value);
                                    getItems(value);
                                }} />
                                Deleted
                            </label>
                            <a href="/remote/new" className="inline-flex items-center gap-1.5 rounded-full bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-950">
                                <IoMdAddCircleOutline size={16} /> New
                            </a>
                        </>} />

                    {itemsLoading && <ListLoading label="Loading accounts..." />}
                    {(!itemsLoading && itemsError) && <ErrorState error={itemsError} />}

                    {(!itemsLoading && !itemsError && items.length === 0) &&
                        <ListEmpty
                            message="No remote accounts yet"
                            action={<a href="/remote/new" className="inline-block rounded-full bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-950">Purchase a remote</a>} />}

                    {(!itemsLoading && !itemsError && items.length > 0) && <>

                        {/* Mobile: one card per row */}
                        <div className="mt-6 grid grid-cols-1 gap-4 lg:hidden">
                            {items.map((item: any, index: number) => {
                                const { status, uptime, errors }: any = getData(item, statusList);
                                const expiration = item.date_expiration ? moment(item.date_expiration).format('MMM D, YYYY') : '(n/a)';
                                const online = status === 'online';

                                return (
                                    <div
                                        key={`${index}-grid`}
                                        className="flex flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition hover:border-emerald-300 hover:shadow-md">
                                      <div className="p-5">

                                        <div className="flex items-start justify-between gap-2">
                                            <div className="flex min-w-0 items-start gap-2">
                                              <ExpandButton item={item} />
                                              <a href={`/remote/${item.ref ?? ''}`} className="min-w-0">
                                                <div className="flex items-center gap-2">
                                                    <h3 className="truncate text-sm font-semibold text-slate-900">{item.label ?? item.user ?? '(unknown)'}</h3>
                                                    {item.expired && <span className="shrink-0 rounded-full bg-red-50 px-2 py-0.5 text-[10px] font-semibold text-red-600">Expired</span>}
                                                </div>
                                                <p className="mt-1 truncate text-xs text-slate-500">{item.user}</p>
                                              </a>
                                            </div>

                                            {(!statusList || statusLoading) ? (
                                                <span className="inline-block h-6 w-20 shrink-0 animate-pulse rounded-full bg-slate-200/80" />
                                            ) : (
                                                <span className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest ${item.deleted ? 'bg-slate-100 text-slate-400' : errors?.length > 0 ? 'bg-amber-50 text-amber-600' : online ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-400'}`}>
                                                    <span className={`h-1.5 w-1.5 rounded-full ${item.deleted ? 'bg-slate-300' : errors?.length > 0 ? 'bg-amber-500' : online ? 'bg-emerald-500' : 'bg-slate-300'}`} />
                                                    {item.deleted ? 'Deleted' : errors?.length > 0 ? 'Issue' : online ? 'Online' : 'Offline'}
                                                </span>
                                            )}
                                        </div>

                                        <div className="mt-3 grid grid-cols-2 gap-y-2 text-sm">
                                            <div>
                                                <p className="text-xs text-slate-400">VPN</p>
                                                <p className="font-medium uppercase text-slate-700">{item.service}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs text-slate-400">Port</p>
                                                <p className="font-medium text-slate-700">{item.to_port}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs text-slate-400">Expires</p>
                                                <p className={`font-normal ${item.expired ? 'text-red-600' : 'text-slate-700'}`}>{expiration}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs text-slate-400">Uptime</p>
                                                <p className="font-normal text-slate-700">{uptime ?? '\u2014'}</p>
                                            </div>
                                        </div>

                                      </div>
                                      <CardActions item={item} status={status} errors={errors} />
                                    </div>
                                );
                            })}
                        </div>

                        {/* Desktop: list rows */}
                        <div className="mt-6 hidden overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm lg:block">

                            <div className="hidden border-b border-slate-100 px-5 py-3 text-xs font-bold uppercase tracking-wider text-slate-400 lg:grid lg:gap-3 lg:grid-cols-[32px_minmax(170px,1.3fr)_minmax(150px,1fr)_70px_140px_120px]">
                                <span></span>
                                <span>Name</span>
                                <span>Remote URL</span>
                                <span>Port</span>
                                <span>Expires</span>
                                <span>Status</span>
                            </div>

                            {items.map((item: any, index: number) => {
                                const { status, errors }: any = getData(item, statusList);
                                const expiration = item.date_expiration ? moment(item.date_expiration).format('MMM D, YYYY') : '(n/a)';
                                const online = status === 'online';
                                const remoteUrl = `${item.from_address}:${item.from_port}`;

                                return (
                                    <div key={`${index}-row`} className="border-b border-slate-100 last:border-b-0">
                                      <div className="px-5 py-4 transition hover:bg-slate-50 lg:grid lg:gap-3 lg:grid-cols-[32px_minmax(170px,1.3fr)_minmax(150px,1fr)_70px_140px_120px] lg:items-center">

                                        <ExpandButton item={item} />

                                        <a href={`/remote/${item.ref ?? ''}`} className="block min-w-0">
                                            <p className="truncate text-sm font-semibold text-slate-900 hover:text-emerald-600">{item.label ?? item.user ?? '(unknown)'}</p>
                                            <p className="truncate text-xs text-slate-400">{item.user}</p>
                                        </a>

                                        <div className="hidden min-w-0 flex-row items-center gap-1.5 lg:flex">
                                            <span className="truncate text-sm text-slate-600">{remoteUrl}</span>
                                            {online && !item.deleted && (
                                                <button
                                                    type="button"
                                                    aria-label="Copy remote URL"
                                                    className="shrink-0 rounded-md p-1 text-slate-400 transition hover:bg-slate-100 hover:text-emerald-600"
                                                    onClick={(e) => { e.preventDefault(); copyValue(`url-${item.id}`, remoteUrl); }}>
                                                    {copiedId === `url-${item.id}`
                                                        ? <FaClipboardCheck size={13} className="text-emerald-500" />
                                                        : <FaRegClipboard size={13} />}
                                                </button>
                                            )}
                                        </div>
                                        <p className="hidden text-sm text-slate-600 lg:block">{item.to_port}</p>
                                        <p className={`hidden text-sm lg:block ${item.expired ? 'text-red-600' : 'text-slate-600'}`}>{expiration}</p>

                                        <span className={`mt-2 inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest lg:mt-0 ${item.deleted ? 'bg-slate-100 text-slate-400' : errors?.length > 0 ? 'bg-amber-50 text-amber-600' : online ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-400'}`}>
                                            <span className={`h-1.5 w-1.5 rounded-full ${item.deleted ? 'bg-slate-300' : errors?.length > 0 ? 'bg-amber-500' : online ? 'bg-emerald-500' : 'bg-slate-300'}`} />
                                            {item.deleted ? 'Deleted' : errors?.length > 0 ? 'Issue' : online ? 'Online' : 'Offline'}
                                        </span>

                                      </div>
                                      <CardActions item={item} status={status} errors={errors} />
                                    </div>
                                );
                            })}
                        </div>

                    </>}

                </section>

            </Layout>

            <PaymentNoticeDialog />

            {confirmOpen && <ConfirmDialog open={confirmOpen} onClose={(value: any) => {
                if (!actionLoading && !actionError && !actionMessage) {
                    clearConfirm();
                }
            }} clearConfirm={clearConfirm} confirmTitle={confirmTitle} confirmMessage={confirmMessage} actionLoading={actionLoading} executeConfirm={executeConfirm} actionError={actionError} actionMessage={actionMessage} />}

            {isOpenChangeServerModal && <ChangeServerModal open={isOpenChangeServerModal} onClose={(value: any) => {
                setChangeServerData(null);
                setOpenChangeServerModal(false);
                if (value === 'refresh') {
                    getItems(showDeleted);
                }
            }} data={changeServerData} servers={servers} setServers={setServers} />}
        </>
    )

}


type ItemObj = {
    items: any[],
    loading: boolean,
    statusLoading?: boolean,
    statusList?: any,
    error: string | TrustedHTML,
    actionId: string,
    setAction: (action: string, obj: any) => any,
    activeId: string,
    setActive: (id: string) => any,
    className?: string,
}

function ConfirmDialog({ open, onClose, clearConfirm, actionLoading, confirmTitle, confirmMessage, executeConfirm, actionMessage, actionError, }: any) {

    return <Dialog open={open} onClose={onClose} className="relative z-[60]">
        <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-[60] w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center items-center">
                <DialogPanel
                    transition
                    className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all max-w-lg data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >

                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">

                        <div className="sm:flex sm:items-start">

                            <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-${actionError ? 'red' : actionMessage ? 'green' : 'blue'}-200 sm:mx-0 sm:h-10 sm:w-10`}>
                                <FaQuestion aria-hidden="true" className={`h-6 w-6 text-blue-700 ${(actionError || actionMessage) && 'hidden'}`} />
                                <FaCheck aria-hidden="true" className={`h-6 w-6 text-green-600 ${!actionMessage && 'hidden'}`} />
                                <FaExclamation aria-hidden="true" className={`h-6 w-6 text-red-600 ${!actionError && 'hidden'}`} />
                            </div>

                            <div className="mt-3 text-center sm:ml-4 lg:mt-0 sm:text-left">
                                <DialogTitle as="h3" className="leading-none text-base font-semibold leading-6 text-gray-900">{confirmTitle}</DialogTitle>
                                <div className="mt-2">
                                    <div className="text-sm text-gray-700"><div dangerouslySetInnerHTML={{ __html: actionError ? actionError : actionMessage ? actionMessage : confirmMessage }} /></div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="bg-gray-50 px-4 py-3 flex flex-row justify-center sm:justify-end gap-3">

                        <button
                            className={`disabled:bg-gray-500 h-[30px] w-[80px] flex flex-row items-center justify-center bg-blue-600 text-sm font-medium rounded-md text-white shadow-sm hover:bg-blue-500 active:bg-blue-700 ${(actionError || actionMessage) && 'hidden'}`}
                            disabled={actionLoading}
                            onClick={executeConfirm}>
                            {actionLoading && <Spinner className='inline mr-2' />}YES
                        </button>

                        <button
                            type="button"
                            disabled={actionLoading}
                            onClick={clearConfirm}
                            className="disabled:bg-gray-500 inline-flex h-[30px] w-[80px] flex flex-row items-center justify-center rounded-md bg-white text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        >
                            {actionError || actionMessage ? 'OK' : 'NO'}
                        </button>
                    </div>
                </DialogPanel>
            </div>
        </div>
    </Dialog>;

}

function getData(item: any, list: any[]) {

    var status = 'offline';
    var uptime = null;
    var remote_ip = null;
    var local_ip = null;

    const interfaces: any[] = [];
    const nats: any[] = [];
    const routes: any[] = [];
    const addresses: any[] = [];

    const data = list?.find((value: any) => value.servers?.includes(item.server));

    if (data) {

        const active = data.active?.values?.find((value: any) => value.name === item.user);
        if (active) {
            status = 'online';
            uptime = active.uptime;
            remote_ip = active['caller-id'];
            local_ip = active.address;

            const int = data.interfaces.values.find((value: any) => value.name === `<${item.service}-${item.user}>`);

            if (int) {

                if (int.running !== 'true') {
                    interfaces.push('Remote access not available');
                }

            }

            const nat = data.nat?.values.find((value: any) => value.comment === item.user);
            if (nat) {
                if (nat.action !== 'dst-nat') {
                    nats.push('Invalid nat: action');
                }
                if (nat.chain !== 'dstnat') {
                    nats.push('Invalid nat: chain');
                }
                if (nat['dst-port'].toString() !== item.from_port.toString()) {
                    nats.push('Invalid nat: dst-port');
                }
                if (nat['to-addresses'] !== local_ip) {
                    nats.push('Invalid nat: to-addresses');
                }
                if (nat['to-ports'].toString() !== item.to_port.toString()) {
                    nats.push('Invalid nat: to-ports');
                }
                if (nat.invalid === 'true') {
                    nats.push('Invalid nat: invalid');
                }
            } else {
                nats.push('Missing nat configuration');
            }

            const route = data.route?.values.find((value: any) => value.gateway === `<${item.service}-${item.user}>`);
            if (route) {
                //dst-address: "111.1.112.250/32"
                const split = route['dst-address'].split('/');
                if (split[0] !== local_ip) {
                    routes.push('Invalid route: dst-address');
                }
            } else {
                routes.push('Missing route configuration');
            }

            const address = data.address?.values.find((value: any) => value.interface === `<${item.service}-${item.user}>`);
            if (address) {

                if (address.invalid === 'true') {
                    addresses.push('Invalid address: invalid');
                } else {

                    if (address.network !== local_ip) {
                        addresses.push('Invalid address: network');
                    } else {

                        const split = address.address.split('/');
                        const arr1 = split[0].split('.');
                        const output = arr1.pop();
                        const ip2 = arr1.join('.');

                        const arr2 = local_ip.split('.');
                        arr2.pop();
                        const ip1 = arr2.join('.');

                        if (ip2 !== ip1) {
                            addresses.push('Invalid address: subnet');
                        }

                        if (output !== '1') {
                            addresses.push('Invalid address: gateway');
                        }
                    }
                }

            } else {
                addresses.push('Missing address configuration');
            }
        }
    }

    const errors: any[] = [...item?.errors ?? [], ...nats, ...routes, ...addresses, ...interfaces];

    return { status, uptime, remote_ip, errors };
}

function ChangeServerModal({ open, onClose, data, servers, setServers }: any) {

    const [error, setError] = useState('');
    const [serverLoading, setServerLoading] = useState(false);
    const [server, setServer] = useState('');

    const [updatingServer, setUpdatingServer] = useState(false);
    const serverRef = useRef<any>();

    const [state, setState] = useState(Date.now());
    const [dialogInfo, setDialogInfo] = useState<any>();


    useEffect(() => {
        if (!servers) {
            getServers();
        }
    }, [servers]);

    async function getServers() {
        setServerLoading(true);
        try {
            const res = await api.get('/remote/server');
            const json = await res.json();

            if (res.ok) {
                setServers(json);
            } else {
                setError(json.error);
            }

        } catch (error: any) {
            setError(error.message);
        }
        setServerLoading(false);
    }

    function getServerName() {
        if (servers) {
            const find = servers.find((item: any) => item.name === data?.server);
            if (find) {
                return find.label;
            }
        }

        return data?.from_address;
    }

    function getAvailableServers() {
        if (servers) {
            return servers.filter((item: any) => item.name !== data?.server);
        }
        return [];
    }

    function getOldRemoteUrl() {
        if (data) {
            return data.to_port === '443' ? `https://${data.from_address}:${data.from_port}` : `${data.from_address}:${data.from_port}`;
        }
        return '';
    }

    function getNewRemoteUrl() {
        if (data && server) {
            const find = servers.find((item: any) => item.name === server);
            if (find) {
                return data.to_port === '443' ? `https://${find.domain}:${data.from_port}` : `${find.domain}:${data.from_port}`;
            }
        }
        return '';
    }

    function getNewServerDomain() {
        if (data && server) {
            const find = servers.find((item: any) => item.name === server);
            if (find) {
                return find.domain;
            }
        }
        return '';
    }

    async function checkServers() {

        if (serverRef.current?.old?.ok && serverRef.current?.new?.ok) {
            return setDialogInfo({ title: 'Confirm Change Server', message: 'Are you sure you want to change account server?', type: 'I' });
        }

        setError('');
        setUpdatingServer(true);
        serverRef.current = { old: { checking: true } };
        setState(Date.now());

        try {
            const res = await api.post(`/remote/server/${data?.server}/check`);
            const json = await res.json();
            if (res.ok) {
                serverRef.current.old.ok = true;
            } else {
                serverRef.current.old.error = json.error;
            }
        } catch (error: any) {
            serverRef.current.old.error = error.message;
        }

        setState(Date.now());
        await new Promise((resolve) => setTimeout(resolve, 500));

        serverRef.current.new = { checking: true };
        setState(Date.now());
        await new Promise((resolve) => setTimeout(resolve, 500));

        try {
            const res = await api.post(`/remote/server/${server}/check`);
            const json = await res.json();
            if (res.ok) {
                serverRef.current.new.ok = true;
            } else {
                serverRef.current.new.error = json.error;
            }
        } catch (error: any) {
            serverRef.current.new.error = error.message;
        }

        setState(Date.now());
        if (serverRef.current.old.ok && serverRef.current.new.ok) {
            await new Promise((resolve) => setTimeout(resolve, 200));
            setDialogInfo({ title: 'Confirm Change Server', message: 'Are you sure you want to change account server?', type: 'I' });
        } else {
            setError('Server error checking. Please check the error details');
        }
        setUpdatingServer(false);
    }

    async function changeServer() {

        setError('');
        setDialogInfo(null);
        setUpdatingServer(true);

        try {

            const res = await api.post(`/remote/${data?.ref}/server/${server}`);
            const json = await res.json();

            if (res.ok) {
                setDialogInfo({ title: 'Server Change Success', message: json.message, type: 'O' });
            } else {
                setError(json.error);
                setUpdatingServer(false);
            }

        } catch (error: any) {
            setError(error.message);
            setUpdatingServer(false);
        }

    }

    function closeAndRefresh() {
        onClose('refresh');
    }


    return <>
        <Dialog open={open} onClose={() => {
            if (!updatingServer) {
                onClose(false);
            }
        }} className="relative z-[60]">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-[60] w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center text-center items-center">
                    <DialogPanel
                        transition
                        className="flex flex-col transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full sm:w-[639px] data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className='bg-blue-600 text-white h-[60px] flex flex-row items-center gap-x-2 font-medium text-lg px-4 border-b border-gray-300'>
                            <CiServer /><div><div>Change Account Server</div></div>
                        </div>

                        <div className='grow mb-4 overflow-y-auto'>
                            <div className='px-5 sm:px-10 py-3 flex flex-col gap-y-2 text-xs'>

                                <div className='flex flex-col sm:flex-row'>
                                    <div className='w-[100px] shrink-0'>Account:</div>
                                    <div>
                                        <div className='font-bold tracking-wide text-sm leading-none'>{data?.user}</div>
                                        <div>{data?.label}</div>
                                    </div>
                                </div>

                                <div className='flex flex-col sm:flex-row lg:items-center'>
                                    <div className='w-[100px] shrink-0'>Remote Url:</div>
                                    <div className='flex min-h-[34px] w-[250px] items-center rounded-xl bg-slate-50 px-3 tracking-wide ring-1 ring-slate-200'>{getOldRemoteUrl()}</div>
                                </div>

                                <div className='flex flex-col sm:flex-row lg:items-center'>
                                    <div className='w-[100px] shrink-0'>From:</div>

                                    <div className='relative flex items-center'>
                                        <div className='flex min-h-[34px] w-[250px] flex-row items-center gap-x-1 rounded-xl bg-slate-50 px-3 ring-1 ring-slate-200'>
                                            <div className='font-bold leading-none'>{getServerName()}</div>
                                            <div className='tracking-wide leading-none text-[11px]'>({data?.from_address})</div>
                                        </div>
                                        {serverLoading && <Spinner className='right-[5px] absolute h-[15px] w-[15px] text-blue-500' />}
                                    </div>

                                    {serverRef.current?.old && <div className='ml-2'>
                                        {(serverRef.current?.old?.checking && !serverRef.current?.old?.ok && !serverRef.current?.old?.error) && <Spinner className='h-[20px] w-[20px] text-blue-500' />}
                                        {serverRef.current?.old?.ok && <FaCircleCheck size={16} className='text-green-500' />}

                                        {serverRef.current?.old?.error && <div className='group relative flex justify-center'>
                                            <FaTimesCircle size={16} className='text-red-500' />
                                            <span className="whitespace-nowrap absolute z-10 top-10 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100 flex flex-row items-center gap-x-1">{serverRef.current?.old?.error}</span>
                                        </div>}

                                    </div>}
                                </div>

                                <div className='flex flex-col sm:flex-row lg:items-center'>
                                    <div className='w-[100px] shrink-0'>To:</div>

                                    <div className='relative flex items-center'>

                                        <select
                                            disabled={updatingServer || serverLoading}
                                            value={server}
                                            onChange={e => setServer(e.target.value)}
                                            className={`w-[250px] h-[30px] ring-1 ring-gray-300 rounded-md px-2 outline-none ${updatingServer || serverLoading ? 'appearance-none' : ''}`}>

                                            <option value=''>Select...</option>
                                            {getAvailableServers().map((item: any, index: number) => {
                                                return <option key={`${index}-srv`} value={item.name}>{item.label} ({item.domain})</option>
                                            })}
                                        </select>

                                        {serverLoading && <Spinner className='right-[5px] absolute h-[15px] w-[15px] text-blue-500' />}


                                    </div>

                                    {serverRef.current?.new && <div className='ml-2'>
                                        {(serverRef.current?.new?.checking && !serverRef.current?.new?.ok && !serverRef.current?.new?.error) && <Spinner className='h-[20px] w-[20px] text-blue-500' />}
                                        {serverRef.current?.new?.ok && <FaCircleCheck size={16} className='text-green-500' />}

                                        {serverRef.current?.new?.error && <div className='group relative flex justify-center'>
                                            <FaTimesCircle size={16} className='text-red-500' />
                                            <span className="whitespace-nowrap absolute z-10 top-10 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100 flex flex-row items-center gap-x-1">{serverRef.current?.new?.error}</span>
                                        </div>}

                                    </div>}

                                </div>

                                {server && <div className='sm:ml-[100px] mt-4 flex flex-col gap-y-1'>
                                    <div className='text-red-500 italic'>Your new Remote URL will now:</div>
                                    <div className='flex flex-wrap items-center gap-2 text-sm'>
                                        <div className='font-medium text-gray-600 tracking-wide leading-none line-through'>{getOldRemoteUrl()}</div>
                                        <div><FaArrowRightLong className='text-gray-500 leading-none' /></div>
                                        <div className='font-bold text-blue-600 tracking-wide leading-none'>{getNewRemoteUrl()}</div>
                                    </div>
                                </div>}

                                <div className='sm:ml-[100px] ring-1 ring-red-500 bg-red-100 rounded-md px-2 py-1 mt-4'>
                                    <IoMdInformationCircleOutline className='text-red-700 inline' />
                                    <span> After the successful server change, your old remote URL will no longer work. To connect using the new remote URL, you must manually update the <b>Connect To</b> field of the {data?.service?.toUpperCase()} Client interface account to the new server domain{<>{getNewServerDomain() ? <> (<b>{getNewServerDomain()}</b>)</> : ''}</>} on your device</span>
                                </div>

                                <div className='sm:ml-[100px] ring-1 ring-yellow-500 bg-yellow-100 rounded-md px-2 py-1 flex flex-col gap-y-3'>

                                    <div>
                                        <div>
                                            <span>
                                                <FaRegQuestionCircle className='text-yellow-700 inline' />
                                                <b> How can I make the change if I can’t access my device remotely using the new remote URL after the server change?</b>
                                            </span>
                                        </div>

                                        <div className='mt-1'>
                                            <b>Answer:</b> Go to your device, connect using its local IP address, and manually update the Connect To field.
                                        </div>
                                    </div>

                                    <div>
                                        <div>
                                            <span>
                                                <FaRegQuestionCircle className='text-yellow-700 inline' />
                                                <b className='text-blue-600'> WHAT IF MY DEVICE IS FAR AWAY FROM ME RIGHT NOW?</b><br />
                                            </span>
                                        </div>

                                        <div className='mt-1'>
                                            <b className='text-blue-600'>ANSWER:</b> Before changing the server of the account, <a href={`https://kptd.ph/remote/tutorials/how-to-connect-${data?.service}-client${data?.service === 'sstp' && data?.service_port ? `?port=${data.service_port}` : ''}`} rel="noreferrer" target='_blank' className='underline text-blue-600 hover:text-red-500 font-medium'>create a new {data?.service?.toUpperCase()} Client interface</a> using the new server domain{<>{getNewServerDomain() ? <> (<b>{getNewServerDomain()}</b>)</> : ''}</>} with the current credential of the account (username/password) by using the current working remote URL.
                                            <span className='font-[600]'> Just leave the newly created {data?.service?.toUpperCase()} Client interface disconnected for now. Once the account server are changed, it will connect automatically.</span>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            {error && <div className='text-center text-red-500 italic mt-2 mb-4 text-xs'>{error}</div>}
                        </div>

                        <div className='bg-gray-200 h-[50px] flex flex-row items-center justify-end text-xs px-4 gap-x-2'>
                            <button
                                disabled={!server || updatingServer} onClick={checkServers}
                                className='disabled:bg-gray-300 w-[90px] h-[30px] bg-blue-500 rounded-md text-white flex flex-row items-center justify-center gap-x-1'>
                                {updatingServer && <Spinner className='text-white h-[16px] w-[16px]' />}
                                <span>Change</span>
                            </button>
                            <button disabled={updatingServer} onClick={() => onClose(false)} className='disabled:bg-gray-300 ring-1 ring-gray-300 w-[90px] h-[30px] bg-white rounded-md'>Close</button>
                        </div>

                    </DialogPanel>
                </div>
            </div >
        </Dialog >

        {dialogInfo && <ConfirmChangeDialog open={true} onClose={(value: any) => {
            setDialogInfo(null);
        }} confirm={(value: any) => {
            if (value === 'change') {
                changeServer();
            }
            if (value === 'refresh') {
                closeAndRefresh();
            }

        }} info={dialogInfo} />}

    </>;

}

function ConfirmChangeDialog({ open, onClose, info, confirm }: any) {

    return <Dialog open={open} onClose={() => {
        if (info?.type !== 'O') {
            onClose(false);
        }
    }} className="relative z-[60]">
        <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-[60] w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center items-center">
                <DialogPanel
                    transition
                    className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all max-w-lg data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">

                        <div className="sm:flex sm:items-start">

                            <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-${info?.type === 'I' ? 'blue' : info?.type === 'O' ? 'green' : 'gray'}-200 sm:mx-0 sm:h-10 sm:w-10`}>
                                {info?.type === 'I' && <FaQuestion aria-hidden="true" className='h-6 w-6 text-blue-700' />}
                                {info?.type === 'O' && <FaCheck aria-hidden="true" className='h-6 w-6 text-green-700' />}
                            </div>

                            <div className="mt-3 text-center sm:ml-4 lg:mt-0 sm:text-left">

                                <DialogTitle as="h3" className="leading-none text-base font-semibold leading-6 text-gray-900">{info?.title}</DialogTitle>
                                <div className="mt-2">
                                    <div className="text-sm text-gray-700"><div dangerouslySetInnerHTML={{ __html: info?.message }} /></div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="bg-gray-50 px-4 py-3 flex flex-row justify-center text-sm sm:justify-end gap-3">

                        {info.type === 'I' && <div className='flex flex-row gap-3'>
                            <button
                                className='h-[30px] w-[80px] flex items-center justify-center bg-blue-600 font-medium rounded-md text-white hover:bg-blue-500 active:bg-blue-700'
                                onClick={() => confirm('change')}>YES
                            </button>

                            <button
                                className="h-[30px] w-[80px] flex items-center justify-center bg-white font-semibold rounded-md text-gray-900 ring-1 ring-gray-300 hover:bg-gray-50"
                                onClick={() => onClose(false)}>NO
                            </button>
                        </div>}

                        {info.type === 'O' && <button
                            className="h-[30px] w-[80px] flex items-center justify-center bg-white font-semibold rounded-md text-gray-900 ring-1 ring-gray-300 hover:bg-gray-50"
                            onClick={() => confirm('refresh')}>OK
                        </button>}

                    </div>
                </DialogPanel>
            </div>
        </div>
    </Dialog>;

}